// DRY environment variable helpers for browser and Node.js (test)
/**
 * Get an environment variable from import.meta.env (browser/Vite) or process.env (Node/test).
 * @param key The environment variable key (e.g. 'VITE_OPENAI_API_KEY')
 * @param defaultValue The value to return if not set
 * @returns The environment variable value or defaultValue or ''
 */
export function getEnvVar(key, defaultValue) {
    if (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env[key]) {
        return import.meta.env[key];
    }
    if (typeof process !== 'undefined' && process.env && process.env[key]) {
        return process.env[key];
    }
    return defaultValue || '';
}
/**
 * Get the OpenAI API key from env.
 */
export function getOpenAiApiKey(defaultValue) {
    return getEnvVar('VITE_OPENAI_API_KEY', defaultValue);
}
/**
 * Get the OpenAI base URL from env.
 */
export function getOpenAiBaseUrl(defaultValue) {
    return getEnvVar('VITE_OPENAI_BASE_URL', defaultValue);
}
/**
 * Get whether log tracking is enabled from env.
 * Returns true if VITE_LOG_TRACKING is set to 'true' or '1'.
 */
export function getLogTrackingEnabled() {
    const value = getEnvVar('VITE_LOG_TRACKING', 'false');
    return value === 'true' || value === '1';
}
/**
 * Get whether performance benchmarking instrumentation is enabled from env.
 * Returns true if VITE_BENCHMARK_INSTRUMENTATION is set to 'true' or '1'.
 */
export function getBenchmarkInstrumentationEnabled() {
    // Allow Playwright init script to force-enable detailed instrumentation
    if (typeof window !== 'undefined' && window.__benchmarkDetailedInstrumentation === true) {
        return true;
    }
    const value = getEnvVar('VITE_BENCHMARK_INSTRUMENTATION', 'false');
    return value === 'true' || value === '1';
}
